import { createReducer } from '@reduxjs/toolkit';

import { fetchProducts } from './actions';

export default createReducer([], {
  [`${fetchProducts}-success`]: (state, { payload: products }) => products,
});
